/* eslint-disable @typescript-eslint/no-explicit-any */
import { OperationVariables, Unmasked } from '@apollo/client'
import { useApolloClient } from '@apollo/client/react'
import { DocumentNode } from 'graphql'
import { useCallback } from 'react'
import useLogger from 'src/context/LoggerProvider/useLogger'

type IUpdateCacheProps<TVariables extends OperationVariables> = {
  query: DocumentNode
  variables?: TVariables
}

function useCacheUpdater<TData, TVariables extends OperationVariables>({
  query,
  variables
}: IUpdateCacheProps<TVariables>) {
  const client = useApolloClient()
  const logger = useLogger()

  const updateCache = useCallback(
    (updateData: (data: TData) => TData) => {
      try {
        const data = client.readQuery<TData, TVariables>({
          query,
          variables
        } as any) as TData | null

        if (!data) return

        client.writeQuery<TData, TVariables>({
          query,
          variables,
          data: updateData(data) as Unmasked<TData>
        } as any)
      } catch (err) {
        logger.warn('Error updating cache', err)
      }
    },
    [client, logger, query, variables]
  )

  return updateCache
}

export default useCacheUpdater
